import(/* webpackMode: "eager" */ "/app/src/app/[locale]/privacy-policy/page.tsx");
